export default __webpack_public_path__ + "static/media/addFontDefault.7d495e6c.svg";